import React from 'react';
import { X, CheckCircle } from 'lucide-react';
import { ReleaseNote } from '../../services/releaseNotesApi';
import '../../styles/components/release-notes-modal.css';

interface ReleaseNotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  releaseNote: ReleaseNote;
}

const ReleaseNotesModal: React.FC<ReleaseNotesModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  releaseNote,
}) => {
  if (!isOpen) return null;

  const allItems = [
    ...(releaseNote.features || []),
    ...(releaseNote.bugFixes || []),
  ];

  return (
    <div className="sm-overlay zoomOutLevel" onClick={onClose}>
      <div className="rn-modal-card" onClick={(e) => e.stopPropagation()}>
        {/* Close button */}
        <button className="rn-close-btn" onClick={onClose} aria-label="Close">
          <X size={18} />
        </button>

        {/* Two-column layout: image left, content right */}
        <div className="rn-modal-layout">
          {/* Left: Device image with dark background and waves */}
          <div className="rn-image-section">
            <img
              src={`${process.env.PUBLIC_URL}/DeviceSetup/release-device-overlay.png`}
              alt="SmartEco Device"
              className="rn-device-img"
            />
          </div>

          {/* Right: Content */}
          <div className="rn-content">
            <span className="rn-version-badge">SYSTEM VERSION {releaseNote.version}</span>
            <h2 className="rn-modal-title">SmartEco Update is Here</h2>
            <p className="rn-modal-description">{releaseNote.description}</p>

            {allItems.length > 0 && (
              <div className="rn-whats-new">
                <h4 className="rn-section-label">WHAT&apos;S NEW</h4>
                <ul className="rn-check-list">
                  {allItems.map((item, index) => (
                    <li key={index} className="rn-check-item">
                      <CheckCircle size={16} className="rn-check-icon" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <button onClick={onConfirm} className="rn-cta-btn">
              Let&apos;s Go
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReleaseNotesModal;
